module.exports = "./img/d85608b29a821f1716ca1160d434c4fa.jpg";